import React from 'react';
import Skeleton, { SkeletonAvatar } from '@pushpay/skeleton';
import { clsx, createUseStyles } from '@pushpay/styles';
import HeaderTemplate from './header-template-old';
import useSharedStyles, { headerHeightMobile } from './use-styles-old';
const useStyles = createUseStyles(theme => ({
  loadingProductSwitcher: {
    width: '136px',
    [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
      width: '72px',
      height: headerHeightMobile,
      padding: `12px ${theme.SPACING.XSMALL}`,
      borderRight: `1px solid ${theme.colors['color-border-surface']}`
    }
  },
  loadingProductSwitcherContent: {
    height: theme.SPACING.LARGE
  },
  skeletonAvatar: {}
}));

const LoadingHeader = ({
  classes: classesProp,
  className: classNameProp,
  mobileMenuButton: mobileMenuButtonProp,
  leftSection: leftSectionProp,
  toolBar,
  rightSection: rightSectionProp,
  'data-pp-at-target': targetId,
  ...rest
}) => {
  const classes = useStyles(classesProp);
  const sharedClasses = useSharedStyles(undefined);
  const className = clsx(sharedClasses.root, classNameProp);
  const mobileMenuButton = mobileMenuButtonProp !== null && mobileMenuButtonProp !== void 0 ? mobileMenuButtonProp : /*#__PURE__*/React.createElement(SkeletonAvatar, {
    size: 32,
    "data-pp-at-target": `${targetId}-mobile-menu-button`
  });
  const leftSection = leftSectionProp !== null && leftSectionProp !== void 0 ? leftSectionProp : /*#__PURE__*/React.createElement(Skeleton, {
    className: classes.loadingProductSwitcher,
    classes: {
      content: classes.loadingProductSwitcherContent
    },
    rows: [{
      width: 100
    }],
    "data-pp-at-target": `${targetId}-product-switcher`
  });
  const rightSection = rightSectionProp !== null && rightSectionProp !== void 0 ? rightSectionProp : /*#__PURE__*/React.createElement(SkeletonAvatar, {
    className: classes.skeletonAvatar,
    size: 32,
    "data-pp-at-target": `${targetId}-avatar`
  });
  return /*#__PURE__*/React.createElement(HeaderTemplate, Object.assign({
    className: className,
    logo: /*#__PURE__*/React.createElement(SkeletonAvatar, {
      size: 40,
      "data-pp-at-target": `${targetId}-logo`
    }),
    mobileMenuButton: mobileMenuButton,
    leftSection: leftSection,
    toolBar: toolBar,
    rightSection: rightSection,
    "data-pp-at-target": "loading-header"
  }, rest));
};

export default LoadingHeader;